import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import CategoryPage from "@/pages/CategoryPage";
import ForeignInvestment from "@/pages/ForeignInvestment";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
};

const Shell = () => {
  useLenis();
  return (
    <div className="sw-grain min-h-screen bg-[color:var(--sw-bg)] text-white">
      <Navbar />
      <ScrollTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/individual" element={<CategoryPage tKey="individual" imageKey="macro_eagle" />} />
          <Route path="/services/company" element={<CategoryPage tKey="company" imageKey="saudi_office" />} />
          <Route path="/services/follow-up" element={<CategoryPage tKey="followup" imageKey="riyadh_night" />} />
          <Route path="/services/e-services" element={<CategoryPage tKey="eservices" imageKey="macro_eagle" />} />
          <Route path="/services/licensing" element={<CategoryPage tKey="licensing" imageKey="saudi_office" />} />
          <Route path="/services/foreign-investment" element={<ForeignInvestment />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster theme="dark" position="top-center" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
